import React, { useState } from 'react';
import './Rebates.scss';
import { Row, Col } from 'react-bootstrap';
import SubmissionForm from './submissionForm';


// function OfferForm(page){
 
//     const [offerCode, setOfferCode] = useState('');
    
//     const handleChange = (event) => {
//       setOfferCode(event.target.value);
//     };
    
//     const handleSubmit = (event) => {
//       alert('An offer code was submitted: ' + offerCode);
//       event.preventDefault();
//     };
    
//     return (
//         <div className='rebates-container'>
//         <div className='rebates-left-column'>
//           <div className='rebates-left-column-content'>
//             Welcome to the Coca Cola Rebate Center
//           </div>
//         </div>
//         <div className='rebates-right-column'>
//           <div className='offer-code-form'>
//             <div className='offer-form-header'>
//               ENTER YOUR OFFER CODE
//             </div>
//             <form onSubmit={handleSubmit} className="offer-code-form-custom">
//     <div>
//       <input type='text' placeholder='OFFERCODE1' style={{padding: '3px', height: '38px', width: '250px', borderColor: "#E0E6EB", borderWidth: "1px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px"}} value={offerCode} onChange={handleChange} />
//     </div>
//     <div className="offer-button-container">
//       <button type='submit' style={{borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px"}}>SEARCH</button>
//     </div>
//     </form>
    
    
//           </div>
//         </div>
//       </div>
//     );
    
// }

// function LookUpForm(){
//         const [offerCode, setOfferCode] = useState('');
        
//         const handleChange = (event) => {
//           setOfferCode(event.target.value);
//         };
        
//         const handleSubmit = (event) => {
//           alert('An offer code was submitted: ' + offerCode);
//           event.preventDefault();
//         };

//     return (<div className='lookup-form-container'>
// <div className='lookup-form-content'>
//     <h1>CHECK EXISTING SUBMISSION</h1>
//     <h3>Search by submission number, email, phone, or full name and zip/postal together</h3>
// </div>
// <div className='lookup-form'>
// <form onSubmit={handleSubmit} className="lookup-form-custom">
//     <div>
//       <input type='text' placeholder='john@example.com' value={offerCode} onChange={handleChange} />
//     </div>
//     <div className="lookup-button-container">
//       <button type='submit' style={{
//         //   borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px"
//         background: 'linear-gradient(0deg, #0071CE, #0071CE), linear-gradient(0deg, #FFFFFF, #FFFFFF)' 

//           }}>SEARCH</button>
//     </div>
//     </form>
// </div>
//     </div>)
// }

function Rebates(page) {
  let pageData=page.page
return (<>
    {/* <OfferForm/> */}
    <SubmissionForm page={pageData}/>
    {/* <LookUpForm/> */}
</>
)
}

export default Rebates;
